
import { forgetVehicleCartContexts } from '@/utils/productCartContextStorage'

export default {
  name: 'ProductVehicleContextBar',

  computed: {
    vehicleContext() {
      return this.$store.getters['breadcrumb/vehicle']
    },
    vehicleLabel() {
      if (!this.vehicleContext) return ''
      return [this.vehicleContext.brand_name, this.vehicleContext.name]
        .filter(Boolean)
        .join(' ')
    },
    vehiclePageLink() {
      if (!this.vehicleContext) return null
      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: this.vehicleContext.params,
      })
    },
  },

  methods: {
    dismiss() {
      forgetVehicleCartContexts(this.vehicleContext?.id)
      this.$store.dispatch('breadcrumb/clearVehicleContext')
    },
  },
}
